/* eslint-disable max-len */
import { getQueryParam } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Breakpoints } from 'common/enums';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { useMediaQuery } from 'hooks/use-media-query';
import { VaultCard } from 'pages/sign-up-onboarding/components/vault-card/vault-card';
import styles from './sign-in-onboarding.module.scss';
import { SignInForm } from './components/sign-in-form/sign-in-form';
import { ResetPassword } from './components/reset-password/reset-password';

const SignInOnboarding: React.FC = () => {
  const email = getQueryParam('email') ?? undefined;
  const name = getQueryParam('name') ?? undefined;
  const token = getQueryParam('token') ?? undefined;
  const vaultId = getQueryParam('vault_id') ?? undefined;
  const ownerName = getQueryParam('owner_name') ?? undefined;
  const [vaultTitle, setVaultTitle] = useState<string>('');
  const [vaultIcon, setVaultIcon] = useState<string | undefined>('');

  const [showResetPassword, setShowResetPassword] = useState<boolean>(false);

  const isMobile = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);

  const fetchVault = async () => {
    const response = await VaultsController.getVaultForInvite(
      Number(vaultId),
      token || '',
    );
    setVaultTitle(response.title);
    setVaultIcon(response.coverUrl);
  };

  useEffect(() => {
    fetchVault();
  }, [token]);

  const onClickResetPassword = () => {
    setShowResetPassword(true);
  };

  return (
    <div className={styles.containerVault}>
      {!isMobile && (
        <VaultCard
          image={vaultIcon}
          name={vaultTitle}
          subtitle="A life story"
        />
      )}
      <div className={styles.container}>
        {showResetPassword ? (
          <ResetPassword onClickBack={() => setShowResetPassword(false)} />
        ) : (
          <SignInForm
            email={email ?? ''}
            vaultOwnerName={ownerName ?? ''}
            ownerName={name ?? ''}
            vaultId={vaultId ?? ''}
            handleResetPassword={onClickResetPassword}
          />
        )}
      </div>
    </div>
  );
};

export { SignInOnboarding };
